import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import ErrorMessage from '../ErrorMessage';
import { InputProps } from '../Input';
import TopFieldContent from '../TopFieldContent';
import CharactersCount from '../CharactersCount/CharactersCount';
import useFormName from '../../../../../../Hooks/useFormName';

interface InputFieldProps extends InputProps {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	placeholder?: string;
	charactersLimit?: number;
	onSubmit: (values: any) => any;
}

const InputWithSubmitField = ({
	name,
	label,
	isRequired,
	className,
	placeholder,
	charactersLimit,
	onSubmit,
	...inputProps
}: InputFieldProps) => {
	const { fieldName } = useFormName({ name });
	const { handleSubmit } = useFormContext();

	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
		defaultValue: '',
	});

	const handlePress = () => {
		handleSubmit(onSubmit, (errors, event) => {})();
	};

	return (
		<div className='form-group'>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<div className='input-group'>
				<input className='form-control' {...inputProps} {...field} />
				<button
					className='btn-submit-in-group'
					type='button'
					onClick={handlePress}
				>
					<i className='fa-solid fa-angle-right' aria-hidden='true'></i>
				</button>
			</div>
			{error?.message && <ErrorMessage tx={error.message} />}
			{charactersLimit && (
				<CharactersCount limit={charactersLimit} value={field.value} />
			)}
		</div>
	);
};

export default InputWithSubmitField;
